// extracted by mini-css-extract-plugin
export default {"wrapper":"RoleAndPermissions_wrapper__7S5+y"};